import React, { useState } from "react";
import "../../Styles/yellowcalf.css/Accountant.css";
import { FaBell, FaSearch, FaPrint, FaGraduationCap } from "react-icons/fa"; 

function Accountant() {
  
  const [selectedStudent, setSelectedStudent] = useState("");

  const handleSelect = (e) => {
    setSelectedStudent(e.target.value);
  };

  const handleClear = () => {
    setSelectedStudent("");
  };
  return (
    <div className="acc-main-content" style={{ paddingTop: "20px" }}>
      <div className="acc-container">
        {/* Top Row Cards */}
        <div className="acc-row">
          <div className="acc-col-12">
            <div className="acc-panel-white acc-mb">
              <div className="acc-panel-body">
                <div className="acc-row">
                  <div className="acc-col-3">
                    <div className="acc-card acc-card-fee">
                      <div className="acc-card-body">
                        <h5 className="acc-card-title">Todays Fee Collection</h5>
                        <h3 className="acc-card-text">
                          <span className="acc-text-big">$ </span>0
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className="acc-col-3">
                    <div className="acc-card acc-card-busfare">
                      <div className="acc-card-body">
                        <h5 className="acc-card-title">Todays Busfare Collections</h5>
                        <h3 className="acc-card-text">
                          <span className="acc-text-big">$ </span>0
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className="acc-col-3">
                    <div className="acc-card acc-card-wallet">
                      <div className="acc-card-body">
                        <h5 className="acc-card-title">Todays Wallet Recharge</h5>
                        <h3 className="acc-card-text">
                          <span className="acc-text-big">$ </span>0
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className="acc-col-3">
                    <div className="acc-card acc-card-collection">
                      <div className="acc-card-body">
                        <h5 className="acc-card-title">
                          Todays Final Due & Registration Collection
                        </h5>
                        <h3 className="acc-card-text">
                          <span className="acc-text-big">$ </span>0
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Middle Row Panels */}
        <div className="acc-row">
          <div className="acc-col-12">
            <div className="acc-panel-white">
              <div className="acc-panel-body">
                <div className="acc-row">
                  <div className="acc-col-4">
                    <div className="acc-panel acc-panel-payment acc-height-box">
                      <div className="acc-panel-body acc-padding-20 acc-text-center">
                        <div className="acc-space10">
                          <h5 className="acc-text-white acc-semi-bold acc-no-margin acc-pb-5">
                            <strong>Pending Payments</strong>
                          </h5>
                          <h3 className="acc-text-white acc-no-margin acc-label-txt">
                            <span className="acc-text-big">$ </span>86977
                          </h3>
                          <h6 className="subinfo-text-white">28 Invoices</h6>
                        </div>
                        <span className="acc-text-light">
                          <a href="/accountant/invoice" className="acc-link-white">
                            <i className="fa fa-external-link-square"></i> View
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="acc-col-4">
                    <div className="acc-panel acc-panel-feedues acc-height-box">
                      <div className="acc-panel-body acc-padding-20 acc-text-center">
                        <div className="acc-space10">
                          <h5 className="acc-text-white acc-semi-bold acc-no-margin acc-pb-5">
                            <strong>Pending Fee Dues</strong>
                          </h5>
                          <h3 className="acc-text-white acc-no-margin acc-label-txt">
                            <span className="acc-text-big">$ </span>5144263
                          </h3>
                         <h6 className="subinfo-text-white">Fee Dues</h6> 
                        </div>
                        <span className="acc-text-light">
                          <a href="/PendingInvoices" className="acc-link-white">
                            <i className="fa fa-external-link-square"></i> View
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="acc-col-4">
                    <div className="acc-panel acc-panel-upecomingfee acc-height-box">
                      <div className="acc-panel-body acc-padding-20 acc-text-center">
                        <div className="acc-space10">
                          <h5 className="acc-text-white acc-semi-bold acc-no-margin acc-pb-5">
                            <strong>Upcoming Fee</strong>
                          </h5>
                          <h3 className="acc-text-white acc-no-margin acc-label-txt">
                            <span className="acc-text-big">$ </span>0
                          </h3>
                          <h6 className="subinfo-text-white">Fee Dues</h6> 
                        </div>
                        <span className="acc-text-light">
                          <a href="/UpcomingInvoices" className="acc-link-white">
                            <i className="fa fa-external-link-square"></i> View
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Student Dropdown */}
        <div className="acc-vacation-index acc-align-buttons">
          <div className="acc-row">
            <div className="acc-col-12">
              <div className="acc-reportkey" align="center">
                <div className="acc-panel-white">
                  <div className="acc-panel-body">
                    <div className="acc-row">
                      <div className="acc-col-11">
                        <select
                          id="acc-student-select"
                          className="acc-form-control acc-search-select"
                          name="student"
                           value={selectedStudent}
                          onChange={handleSelect}
                        >
                          <option value="">Select Student</option>
                          <option value="1">Student 1</option>
                          <option value="2">Student 2</option>
                        </select>
                      </div>
                      <div className="acc-col-1">
                        <button
                          type="reset"
                          className="acc-btn acc-btn-blue"
                          onClick={handleClear}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         {selectedStudent && (
          <div className="mt-4">
            <StudentDetail studentName={selectedStudent} />
          </div>
        )}
      </div>
    </div>
  );
}
const StudentDetail = ({ studentName }) => (
  <div className="container-fluid p-4" style={{ backgroundColor: "#f8f8f8" }}>
    <div className="text-center mb-3">
      <h5 className="py-2 bg-light rounded shadow-sm">{studentName}</h5>
    </div>

    <div className="row bg-white shadow-sm rounded p-3 mb-4">
      <div className="col-md-2 text-center border-end">
        <FaGraduationCap size={70} className="text-secondary mb-2" />
      </div>
     <div className="col-md-5">
  <h6 className="fw-bold mb-2">Student Details</h6>
  <table className="table table-striped table-bordered table-sm mb-0">
    <tbody>
      <tr>
        <td className="fw-semibold">Name</td>
        <td>{studentName}</td>
      </tr>
      <tr>
        <td>Admission Number</td>
        <td>1234</td>
      </tr>
      <tr>
        <td>Student Email</td>
        <td>sample@mail.com</td>
      </tr>
      <tr>
        <td>Contact Number</td>
        <td>9876543210</td>
      </tr>
    </tbody>
  </table>
</div>
     <div className="col-md-5">
  <h6 className="fw-bold mb-2">Parent Details</h6>
  <table className="table table-striped table-bordered table-sm mb-0">
    <tbody>
      <tr>
        <td className="fw-semibold">Name</td>
        <td>Parent Name</td>
      </tr>
      <tr>
        <td>Parent Email</td>
        <td>parent@mail.com</td>
      </tr>
      <tr>
        <td>Contact Number</td>
        <td>9876500012</td>
      </tr>
      <tr>
        <td>Last Login</td>
        <td>2025-10-30</td>
      </tr>
    </tbody>
  </table>
</div>
    </div>

         {/* Fee Due Detail */}
      <SectionHeader title="Fee Due Details" />
      <table className="table table-striped table-bordered text-center align-middle">
        <thead className="table-light ">
          <tr>
            <th>Sr No</th>
            <th>Fee Invoice No</th>
            <th>Fee Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="4" className="text-muted align-left">No results found</td>
          </tr>
        </tbody>
      </table>

    

    {/* Wallet Detail */}
    <SectionHeader title="Wallet Detail" />
    <div className="bg-white p-3 rounded shadow-sm mb-4">
      <strong>Wallet Balance:</strong> $0
    </div>


    {/* Last 5 Wallet Recharge */}
    <SectionHeader title="Last 5 Wallet Recharge" />
     <table className="table table-striped table-bordered text-center align-middle">
       <thead className="table-light">
        <tr>
          <th>Sr No</th>
          <th>Amount</th>
          <th>Invoice Date</th>
          <th>Reference No</th>
           <th>Recharge Mode</th>
        </tr>
      </thead>
      <tbody>
          <tr>
            <td colSpan="5" className="text-muted ">No results found</td>
          </tr>
        </tbody>
      </table>

       {/*Last 5 Wallet Transaction */}
    <SectionHeader title="Last 5 Wallet Transaction" />
    <table className="table table-striped table-bordered text-center align-middle">
       <thead className="table-light">
        <tr>
          <th>Sr No</th>
          <th>Sale Amount</th>
          <th>Invoice Date</th>
          <th>Sale Reference No</th>
        </tr>
      </thead>
      <tbody>
          <tr>
            <td colSpan="4" className="text-muted ">No results found</td>
          </tr>
        </tbody>
      </table> 
  </div>
);

/* SECTION HEADER */
const SectionHeader = ({ title }) => (
  <div className="d-flex align-items-center my-3">
    <FaBell className="text-dark me-2" />
    <h6 className="fw-bold mb-0">{title}</h6>
  </div>
);


export default Accountant;
